'use client';

import dynamic from 'next/dynamic';

const ViewboxSlidingDemo = dynamic(
  () => import('./ViewboxSlidingDemo')
);

export default ViewboxSlidingDemo;
